import { setPramaryColor } from "@/assets/style/main";
import { defineStore } from "pinia";
import { ref, watch } from "vue";

export const useStore = defineStore("store", () => {
  const test = ref("");
  const shopInfo = ref<any>({
    detail_color: ["#FFFFFF", "#AAAAAA", "#E9B112"],
    primaryColor: '#E9B112',
  });

  // 从内存中获取店铺信息
  const initShopInfo = () => {
    const primary_color = localStorage.getItem("primaryColor");
    if (primary_color) {
      shopInfo.value.primaryColor = primary_color;
      setPramaryColor(primary_color);
    };
  }

  return { 
    test,
    shopInfo,
    initShopInfo,
  };
});

export const youhui = defineStore("youhui", () => {
  const couponList = ref<{
    canNotUse: any;
    useCodeIds: any;
  }>(uni.getStorageSync('couponList') || {
    canNotUse: [],
    useCodeIds: [],
  });
  const useCoupon = ref<any>({});  // 当前选中的优惠券
  const selected = ref<any>({});   // 当前选中的时长/套餐 （仅即扫即用）
  const updatepricefn = ref<any>();
  const updatepriceParams = ref<any>({});
  const setCouponList = ({canNotUse, useCodeIds} : {canNotUse: any; useCodeIds: any}) => {
    couponList.value = {
      canNotUse,
      useCodeIds,
    }
  }
  watch(
    couponList,
    (val) => {
      uni.setStorageSync('couponList', val);
    },
    { immediate: true },
  );
  return {
    couponList,
    selected,
    updatepricefn,
    updatepriceParams,
    setCouponList,
    useCoupon,
  };
});
